// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const MondooYellowLogoIcon = createSvgIcon(
  <svg width={88} height={24} fill="none" viewBox="0 0 88 24">
    <path
      fill="url(#mondoo-yellow-logo_svga)"
      fillRule="evenodd"
      d="M1.45 12a6 6 0 0 0 6 6v-5.96a6 6 0 0 0 12 .02V18a6 6 0 0 0 0-12v5.94a6 6 0 0 0-12 .02V6a6 6 0 0 0-6 6m66.22 2.3q.3-.9.3-2.03v-.54q0-1.14-.3-2.02-.3-.9-.84-1.52-.55-.64-1.31-.97a4 4 0 0 0-1.68-.33 4 4 0 0 0-1.68.33q-.75.33-1.3.97-.55.62-.85 1.52-.3.89-.3 2.02v.54q0 1.13.3 2.03.31.9.86 1.52a3.8 3.8 0 0 0 2.98 1.3q.93 0 1.68-.33.75-.34 1.3-.97.56-.63.84-1.52m-1.42-2.59v.56a6 6 0 0 1-.16 1.48q-.15.65-.47 1.09-.3.43-.75.66-.45.22-1.02.22-.56 0-1.01-.22-.45-.23-.77-.66-.31-.45-.47-1.09a6 6 0 0 1-.17-1.48v-.56q0-.83.17-1.47.15-.64.47-1.07.3-.44.76-.66.45-.22 1-.22.58 0 1.03.22t.75.66q.31.43.48 1.07t.16 1.47M39.92 7.02H38.2v6.65q0 .72-.25 1.19-.24.46-.7.67t-1.06.22-1.06-.22q-.45-.21-.7-.67t-.25-1.19V7.02h-1.7v6.65q0 1.15.47 1.9.5.78 1.33 1.16t1.91.38q1.05 0 1.88-.38a3.1 3.1 0 0 0 1.84-3.06zm10.16 9.96V7.02h-1.7v7.15L43.9 7.02h-1.72v9.96h1.72V9.85l4.46 7.13zm8.68-1.36v1.36h-6.24V7.02h1.72v8.6zm17.2-1.88h1.71a4 4 0 0 1-.55 1.74q-.45.75-1.3 1.2-.84.43-2.05.43-.92 0-1.66-.32-.73-.34-1.26-.95t-.8-1.48a7 7 0 0 1-.28-1.94v-.83q0-1.07.28-1.94t.82-1.48q.53-.63 1.28-.96t1.69-.32q1.19 0 2 .43.83.45 1.28 1.21.45.77.56 1.77h-1.71q-.08-.64-.3-1.1-.23-.45-.67-.7a2.4 2.4 0 0 0-1.16-.24q-.6 0-1.03.22-.45.22-.73.64-.3.42-.45 1.05-.14.61-.14 1.4v.85q0 .75.13 1.36.14.61.41 1.05.28.45.71.68t1.03.24q.75 0 1.19-.24.45-.23.69-.67t.31-1.1m5.38-2V7.03h-1.71v9.96h1.71v-3.1l1.15-1.21 3 4.3h2.03l-3.9-5.55 3.7-4.4h-2.09l-2.9 3.5z"
      clipRule="evenodd"
    />
    <defs>
      <linearGradient
        id="mondoo-yellow-logo_svga"
        x1={0.48}
        x2={84.52}
        y1={6.31}
        y2={25.39}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E94A18" />
        <stop offset={1} stopColor="#D3A004" />
      </linearGradient>
    </defs>
  </svg>,
  "MondooYellowLogo",
);
export default MondooYellowLogoIcon;
